import React from 'react';

import PageWithAuth from '../../../../components/PageWithAuth';
import Navigation from '../../components/Navigation';

const DashboardPage = ({ children, title = 'Dashboard', showWaitList = false, description = '' }) => (
  <PageWithAuth title={title} showWaitList={showWaitList} description={description}>
    <Navigation />
    {children}
  </PageWithAuth>
);

export default DashboardPage;
